export const scrollFix = () => {
    document.getElementById('root').scrollIntoView();
}